import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Skills data-id="element-5" />
        <Projects data-id="element-6" />
        <Contact data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}